import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import useTranslator from '../../../translation/hooks/useTranslator';
import { validateCnpj } from '../../../utils/validateCnpj';

export const InputCNPJ = ({ setValue, field, index }) => {
  const [invalidInput, setInvalidInput] = useState(false);
  const { Translation } = useTranslator();

  const handleAccept = (_, maskRef) => {
    const rawValue = maskRef.unmaskedValue;
    const hasInvalidInput = rawValue ? !validateCnpj(rawValue) : false;
    setInvalidInput(hasInvalidInput);
    setValue(hasInvalidInput ? '' : rawValue, index, field.ObjectKey, field.Required, !hasInvalidInput);
  };

  return (
    <>
      {invalidInput && <div className='form-content__validation'>{Translation('FIELDS.INVALID_INPUT')}</div>}
      <IMaskInput
        className={`form-content__input ${invalidInput ? '--invalid' : ''}`}
        mask="**.***.***\/****-00"
        prepareChar={str => str.toUpperCase()}
        onAccept={handleAccept}
        name={field.FieldKey}
        type="text"
        lazy={true}
      />
    </>
  );
};

InputCNPJ.propTypes = {
  setValue: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};
